import { render, staticRenderFns } from "./collection-list.vue?vue&type=template&id=151d0560"
import script from "./collection-list.ts?vue&type=script&lang=js&external"
export * from "./collection-list.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports